import { render, staticRenderFns } from "./OrderForms.vue?vue&type=template&id=592d08ca&scoped=true&"
import script from "./OrderForms.vue?vue&type=script&lang=js&"
export * from "./OrderForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592d08ca",
  null
  
)

export default component.exports